<div class="position-relative lottos-list-item">
  <div class="item-image">
    <!--Sponsor-->
    <ng-container *ngIf="lottoItem?.Sponsor?.SponsorImage">
      <div class="corner-icon-container-sponsor">
        <a
          target="_blank"
          href="{{ lottoItem.Sponsor?.SponsorLink }}"
          [attr.aria-label]="'Sponsor: ' + lottoItem.Sponsor?.SponsorText"
          rel="noopener noreferrer"
        >
          <img src="{{ lottoItem.Sponsor?.SponsorImage | contentImage: '6' : 'lotto' }}" [alt]="lottoItem.Sponsor?.SponsorText" />
        </a>
      </div>
    </ng-container>
    <a
      class="loyalty-item-container lotto"
      [owlRouterLink]="'/rewards/raffles/details/' + lottoItem.LottoId"
      [stopLink]="ignoreLink"
      id="lotto-link"
      [attr.aria-label]="'View details for ' + lottoItem.Title"
    >
      <div class="card loyalty border-0">
        <div>
          <img
            class="card-img-top"
            [src]="lottoItem.ImageName | contentImage: '7' : 'lotto'"
            [alt]="lottoItem.Title"
            [useDefault]="true"
            [loyaltyType]="'lotto'"
            draggable="false"
          />

          <div class="corner-number-entries" *ngIf="lottoItem.NumberOfTicketsPurchasedByAccount" aria-live="polite">
            <span class="number-entries">
              {{ ('lotto.my.entries' | translate) + lottoItem.NumberOfTicketsPurchasedByAccount }}
            </span>
          </div>
        </div>
      </div>
    </a>
  </div>
  <div class="rewards-status-separator justify-content-between align-items-center">
    <ng-container *ngIf="lottoStatus()?.statusText || lottoStatus()?.statusText === LOTTO_STATE.LOCKED">
      @if (lottoStatus()?.statusText === LOTTO_STATE.LOCKED) {
        <div class="rewards-item-panel-status text-info" role="status">
          <span class="icon material-icons me-1 rewards-locked-icon" aria-hidden="true">lock</span>
          {{ 'reward.status.locked' | translate }}
        </div>
      } @else if (lottoStatus()?.statusText !== LOTTO_STATE.VIEW) {
        <div class="rewards-item-panel-status {{ 'status-text-on-' + lottoStatus()?.theme }}" role="status">
          <ng-container *ngIf="lottoStatus()?.statusText == LOTTO_STATE.FEATURED">
            <span class="icon material-icons text-success font-size-20 me-1" aria-hidden="true">{{ featuredIcon }}</span>
          </ng-container>
          {{ lottoStatus()?.statusText | translate }}
        </div>
      }
    </ng-container>
    <!--Item State-->

    @if (
      lottoStatus()?.statusText !== LOTTO_STATE.COMING_SOON &&
      lottoStatus()?.statusText !== LOTTO_STATE.SOLD_OUT &&
      lottoStatus()?.statusText !== LOTTO_STATE.LOCKED
    ) {
      <fgbcl-countdown-v2 [startDateTime]="lottoItem.RequestTime" [endDateTime]="lottoItem.EndDate" (complete)="onLottoEnd()">
      </fgbcl-countdown-v2>
    }
  </div>

  <div class="rewards-item-panel-name">{{ lottoItem.Title }}</div>

  <label class="accessibility-only">Points Value: </label>

  @if (lottoItem.PurchasePrice > 0) {
    @if (lottoStatus()?.statusText !== LOTTO_STATE.SOLD_OUT) {
      <div
        class="rewards-item-panel-value"
        [attr.aria-label]="(lottoItem.PurchasePrice | FortressCurrencyPipe: 'PTS') + ' points'"
      >
        {{ lottoItem.PurchasePrice | FortressCurrencyPipe: 'PTS' }}
      </div>
    }
  } @else {
    <div class="rewards-item-panel-value" aria-label="Free entry">{{ 'fgbcl.lottos.item.free' | translate }}</div>
  }
</div>
